import { Tooltip } from '@mantine/core';
import { Icon, variants } from '@uag/react-core';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/shallow';

import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';
import { PRIMARY_COLOR_ACCENT_HEX } from 'shared/constants';

export const ProjectSaveStatusInfo = () => {
    const { t } = useTranslation();
    const { activeProjectName, hasActiveProject, isDirty, isSaving } = usePlacementStore(
        useShallow((state) => ({
            activeProjectName: state.activeProject?.name ?? null,
            hasActiveProject: state.activeProject !== null,
            isDirty: state.isDirty,
            isSaving: state.isSaving
        }))
    );

    const indicatorText = !hasActiveProject
        ? t('projectsStatusNoSelection')
        : isSaving
          ? t('projectsSaving')
          : isDirty
            ? t('projectsStatusUnsaved')
            : t('projectsStatusSaved');

    const projectLabel = activeProjectName ?? t('projectsStatusNoProject', 'No project');
    const iconColor = isDirty ? '#b35b00' : PRIMARY_COLOR_ACCENT_HEX;
    const iconName = !hasActiveProject ? 'warning' : isDirty ? 'save' : 'check_circle';

    return (
        <Tooltip label={`${projectLabel} · ${indicatorText}`} position="bottom" variant={variants.tooltip.bottom}>
            <div className="flex items-center justify-start max-w-72 h-full gap-1">
                <Icon className="icon-medium" color={iconColor} icon={iconName} />
                <div className="text-xs leading-none truncate">{`${projectLabel} · ${indicatorText}`}</div>
            </div>
        </Tooltip>
    );
};
